import { render, staticRenderFns } from "./SaveFailedToast.vue?vue&type=template&id=96cfbeae&scoped=true&"
import script from "./SaveFailedToast.vue?vue&type=script&lang=ts&"
export * from "./SaveFailedToast.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96cfbeae",
  null
  
)

export default component.exports